import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer-banner',
    templateUrl: './footer-banner.component.html',
    styleUrls: ['./footer-banner.component.scss'],
    standalone: false
})
export class FooterBannerComponent  implements OnInit {

  /** The current year, so the notice is never a year out of date again. */
  readonly year = new Date().getFullYear();

  constructor() { }

  ngOnInit() {}

}
